import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

export default function RelatedMovies({ list }: { list: Movie[] }) {
  if (list.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-700 p-8 text-center text-sm text-foreground-500">
        暂无相关推荐影片。
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {list.map((m) => (
        <Link
          key={m.id}
          to={`/detail/${m.id}`}
          className="group rounded-lg overflow-hidden bg-background-900/70 border border-background-800 hover:border-primary-700 transition-colors"
        >
          <div className="aspect-[2/3] overflow-hidden bg-background-800">
            <img
              src={m.poster}
              alt={`${m.title} 海报`}
              title={`${m.title} 影片推荐`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-3">
            <p className="text-sm text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-1">
              {m.title}
            </p>
            <p className="text-xs text-foreground-500 mt-1">
              {m.year} · {m.region}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}